export default __webpack_public_path__ + "static/media/addIcon.bf6aaa99.svg";